export default __webpack_public_path__ + "static/media/ledger.5c4fa8fa.svg";